import React from 'react';
import PropTypes from 'prop-types';
import WeatherReportItem from './item';

const WeatherReportDetails = ({
  title,
  data,
  poweredByImg,
  poweredByLabel,
  viewFullForecastUrl,
  labelPastSnowball,
  labelTodaySnowball,
  labelTonightsSnowball,
  labelWindSpeed,
  buttonUrl,
  buttonLabel,
  unavailableDataPointMessage
}) => {
  const todayForecastData = data.filter(day => !day.isToday);
  return (
    <div className="weather-report-update__details">
      {!!title && (
        <h2 className="weather-report-update__summary-title">{title}</h2>
      )}
      {!!todayForecastData &&
        todayForecastData.map((item, index) => (
          <div
            className="weather-report-update__accordions-container"
            key={index}
          >
            <WeatherReportItem
              item={item}
              labelPastSnowball={labelPastSnowball}
              labelTodaySnowball={labelTodaySnowball}
              labelTonightsSnowball={labelTonightsSnowball}
              labelWindSpeed={labelWindSpeed}
              unavailableDataPointMessage={unavailableDataPointMessage}
            />
          </div>
        ))}

      {buttonUrl && buttonLabel && (
        <a
          href={buttonUrl}
          className="btn btn_large weather-report-update__button"
        >
          {buttonLabel}
        </a>
      )}
      <div className="weather-report-update__powered-box">
        <a href={viewFullForecastUrl} target="_blank" rel="noreferrer">
          {poweredByLabel}
        </a>
        <img src={poweredByImg} alt={poweredByLabel} loading="lazy" />
      </div>
    </div>
  );
};

WeatherReportDetails.propTypes = {
  title: PropTypes.string,
  poweredByImg: PropTypes.string,
  poweredByLabel: PropTypes.string,
  viewFullForecastUrl: PropTypes.string,
  labelPastSnowball: PropTypes.string.isRequired,
  labelTodaySnowball: PropTypes.string.isRequired,
  labelTonightsSnowball: PropTypes.string.isRequired,
  labelWindSpeed: PropTypes.string.isRequired,
  buttonUrl: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  unavailableDataPointMessage: PropTypes.string.isRequired
};

export default WeatherReportDetails;
